import { qs, qsa, delegate, on } from '../helpers';
import { Form } from '../../forms/form';

export default class View {
	constructor() {

		// stop if wrong page!
		this.linkRequestPage = qs('.page.link-request');
		if (!this.linkRequestPage) {
			return;
		}
		this.initialized = true;

		// find all relevant elements
		this.chosenRoleFormGroup = qs('.row.role .form-group.chosen-role', this.linkRequestPage);
		this.chosenRole = qs('input.chosen-role', this.linkRequestPage);
		this.chosenRoleCaretDown = qs('.role .caret-down', this.linkRequestPage);
		this.chosenRoleCaretUp = qs('.role .caret-up', this.linkRequestPage);
		this.roleOptionsContainer = qs('.options', this.linkRequestPage);
		this.requestAccessButton = qs('button.request-access', this.linkRequestPage);
		this.dislaimerModal = qs('.disclaimer-modal', this.linkRequestPage);
		this.dislaimerModalSubmitButton = qs('button.agree-and-submit', this.dislaimerModal);
		this.dislaimerModalCancelButton = qs('button.cancel', this.dislaimerModal);
		this.documentBody = qs('body', this.document);

		this.setupClickListeners();
	}

	setupClickListeners() {
		// set up click handlers
		// show options on chosen role click
		on(this.chosenRole, "click", () => {
			this.roleOptionsContainer.classList.toggle('hidden');
			this.toggleChosenRoleCaret();
		});

		// hide options and fill out chosen role on an option click
		delegate(this.linkRequestPage, '.options .option', "click", ({ target }) => {
			this.chosenRole.value = target.innerText;
			this.roleOptionsContainer.classList.add('hidden');
			this.requestAccessButton.disabled = false;
			this.toggleChosenRoleCaret();
			this.chosenRoleFormGroup.classList.add('focused');
		})

		// hide options when clicked outside of the options div
		delegate(document, ':not(.option):not(.chosen-role)', "click", ({ target }) => {
			this.roleOptionsContainer.classList.add('hidden');
			this.toggleChosenRoleCaret("down");
		})

		// open modal
		on(this.requestAccessButton, "click", e => {
			this.dislaimerModal.classList.remove('hidden');
			this.documentBody.classList.add('modal-open');
		})

		// close modal
		on(this.dislaimerModalCancelButton, "click", e => {
			this.dislaimerModal.classList.add('hidden');
			this.documentBody.classList.remove('modal-open');
		})

		new Form(qs('form', this.linkRequestPage));
	}

	toggleChosenRoleCaret(direction = null) {
		if (direction == "down"){
			this.chosenRoleCaretDown.classList.remove('hidden');
			this.chosenRoleCaretUp.classList.add('hidden');
			return;
		}
		this.chosenRoleCaretDown.classList.toggle('hidden');
		this.chosenRoleCaretUp.classList.toggle('hidden');
	}

	// restore the view
	resetView() {
		if (!this.linkRequestPage) {
			return;
		}
		this.chosenRole.value = "";
		this.roleOptionsContainer.classList.add('hidden');
		this.requestAccessButton.disabled = true;
	}
}
